import React from "react";
import Story from "../../layouts/Story";
import AreaChart from "./charts/AreaChart";
import StackedAreaChart from "./charts/StackedAreaChart";
import ChoroplethMap from "./charts/ChoroplethMap";
import ChordDiagram from "./charts/ChordDiagram";
import ArrowChart from "./charts/ArrowChart";
import BubbleMatrix from "./charts/BubbleMatrix";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const StorySeven = () => {
  const additionalComponents = {
    areaChart: AreaChart,
    stackedAreaChart: StackedAreaChart,
    worldChoroplethMap: ChoroplethMap,
    chordDiagram: ChordDiagram,
    arrowChart: ArrowChart,
    bubbleMatrix: BubbleMatrix,
  };

  return <Story {...copy} additionalComponents={additionalComponents} />;
};

export default StorySeven;
